import { FunctionalComponent } from 'preact';
import { Ref, useMemo } from 'preact/hooks';
import {
  useCheckoutStore,
  useSelector,
} from '@primer-io/shared-library/contexts';
import CreditCardForm from '../payment-methods/credit-card/CreditCardForm';
import PaymentMethodButton from '../components/PaymentMethodButton';

type Props = {
  otherPaymentMethodsRef: Ref<HTMLDivElement>;
};

const CheckoutPaymentScene: FunctionalComponent<Props> = ({
  otherPaymentMethodsRef,
}) => {
  const store = useCheckoutStore();

  const paymentMethods = useSelector((s) => s.paymentMethods);

  const paymentMethodButtons = useMemo(() => {
    return Object.entries(paymentMethods).filter(([key]) => key !== 'card');
  }, [paymentMethods]);

  return (
    <div
      ref={otherPaymentMethodsRef}
      id='primer-checkout-other-payment-methods'
    >
      <div>
        {paymentMethodButtons.length > 0 && (
          <div
            id='primer-checkout-apm-button-container'
            class='PrimerCheckout__sceneElement PrimerCheckout__apmButtonContainer'
          >
            {paymentMethodButtons.map(([key, paymentMethod]) => (
              <PaymentMethodButton
                key={paymentMethod.displayName}
                id={key}
                paymentMethod={paymentMethod}
              />
            ))}
          </div>
        )}

        {store.hasCard && <CreditCardForm />}
      </div>

      <div></div>
    </div>
  );
};

export default CheckoutPaymentScene;
